import { useEffect } from 'react';

/**
 * モーダル表示中に背景スクロールを禁止するカスタムフック
 *
 * @param {boolean} isLocked - trueのとき背景スクロールを禁止する
 *
 * @example
 * function MyModal({ isOpen }) {
 *   useBodyScrollLock(isOpen);
 *   if (!isOpen) return null;
 *   return <div>...</div>;
 * }
 */
function useBodyScrollLock(isLocked) {
    useEffect(() => {
        if (isLocked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLocked]);
}

export default useBodyScrollLock;
